/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useNavigate } from 'js/lib/useRouter';

import { Tab, TabContext, Tabs } from '@coursera/cds-core';

import _t from 'i18n!nls/skills-common';

type Props = {
  selected: 'skills' | 'skillsets';
  orgSlug: string;
  extraSpacing?: boolean;
};

const styles = {
  container: (extraSpacing?: boolean) => css`
    margin-bottom: var(--cds-spacing-300);
    ${extraSpacing && 'margin: var(--cds-spacing-300);'}
  `,
};

/**
 * Tab component for switching between Skills Tracking and SkillSets views in the enterprise admin dashboard
 *
 * @component
 * @param {('skills'|'skillsets')} props.selected - The currently selected tab
 * @param {string} props.orgSlug - Organization slug for URL construction
 * @param {boolean} [props.extraSpacing] - Whether to add extra spacing around the component
 * @returns {JSX.Element}
 */
const AdminSkillTabs = ({ selected, orgSlug, extraSpacing }: Props) => {
  const navigate = useNavigate();
  return (
    <div css={styles.container(extraSpacing)}>
      <TabContext value={selected}>
        <Tabs>
          <Tab
            label={_t('Skills Tracking')}
            value="skills"
            onClick={() => {
              navigate(`/o/${orgSlug}/admin/skills-tracking`);
            }}
          />
          <Tab
            label={_t('SkillSets')}
            value="skillsets"
            onClick={() => {
              navigate(`/o/${orgSlug}/admin/skill-sets`);
            }}
          />
        </Tabs>
      </TabContext>
    </div>
  );
};

export default AdminSkillTabs;
